import { ErrorState } from "../store/errorSlice";
import { PayloadAction } from "@reduxjs/toolkit";

interface ErrorStateInput {
  errorMessage: string;
  errorTs?: string;
}

export function setInfo(
  state: ErrorState,
  action: PayloadAction<ErrorStateInput>
) {
  state.error = { ...state.error, ...action.payload };
  state.error.errorTs = null;
  state.error.isError = "INFO";
}

export function setError(
  state: ErrorState,
  action: PayloadAction<ErrorStateInput>
) {
  state.error = { ...state.error, ...action.payload };
  state.error.isError = "ERROR";
}
export function hideError(state: ErrorState) {
  state.error.isError = "NONE";
}
export function clearError(state: ErrorState) {
  state.error = {
    isError: "NONE",
    errorMessage: "",
    errorTs: "",
    errorDisplayTime: 10000,
  };
}
